// src/stores/vehicleStore.js
import { defineStore } from "pinia";
export const useBibleStore = defineStore("bibleStore", {
  state: () => ({
    versions: [],
    books: [],
  }),

  actions: {
    async getVersions() {
      try {
        const context = require.context('@/services/data', false, /\.json$/);
        const files = context.keys();
        this.versions = files.map(file => file.replace('./', '').replace('.json', ''));
      } catch (error) {
        console.error("Failed to fetch books:", error);
        throw error;
      }
    },
    
    async getBooks(bookId) {
      try {
        const bookData = await import(`@/services/data/${bookId}.json`);
        this.books = bookData.default;
      } catch (error) {
        console.error("Failed to fetch books:", error);
        throw error;
      }
    },
  },
});
